import React from 'react'

import { useStoreState } from '@mortgage-pos/ui/store'
import Button, { ButtonVariants } from '@mortgage-pos/ui/components/Button'

export enum LOCardVariant {
  horizontal,
  card,
  compare,
}

interface Props {
  heading?: string
  body?: string
  cta?: string
  variant?: LOCardVariant
  onCtaClick?: () => void
}

const defaultProps = {
  heading: 'Not sure if you’re ready to lock? I’m here to help.',
  body: 'This is a big decision and we’re here to assist you with any questions.',
  cta: 'Talk with my loan officer',
}

export const LoanOfficerCard: React.FC<Props> = ({
  heading = defaultProps.heading,
  body = defaultProps.body,
  cta = defaultProps.cta,
  variant = LOCardVariant.horizontal,
  onCtaClick,
}) => {
  const { loanOfficer } = useStoreState((state) => state.loanOfficer)

  if (!loanOfficer) {
    return null
  }

  return (
    <div
      className={getCardModifier('loan-officer-pricing-card', variant)}
      data-testid="pricing-loan-officer-card"
    >
      {loanOfficer.headshot ? (
        <img
          src={loanOfficer.headshot}
          className={getCardModifier(
            'loan-officer-pricing-card__headshot',
            variant
          )}
          alt={`${loanOfficer.name} headshot`}
        />
      ) : null}

      <div
        className={getCardModifier('loan-officer-pricing-card__text', variant)}
      >
        <h4
          className={getCardModifier(
            'loan-officer-pricing-card__heading',
            variant
          )}
        >
          {heading}
        </h4>
        <p
          className={getCardModifier(
            'loan-officer-pricing-card__body',
            variant
          )}
        >
          {body}
          {variant === LOCardVariant.compare ? (
            <button
              className="loan-officer-pricing-card__cta --compare"
              onClick={onCtaClick}
            >
              {cta}
            </button>
          ) : null}
        </p>
      </div>

      {/* TODO: replace with the talk to expert functionality */}
      {variant !== LOCardVariant.compare ? (
        <Button
          className={getCardModifier('loan-officer-pricing-card__cta', variant)}
          content={cta}
          variant={ButtonVariants.skip}
          onClick={onCtaClick}
        />
      ) : null}
    </div>
  )
}

function getCardModifier(className: string, variant: LOCardVariant): string {
  return [
    className,
    variant === LOCardVariant.card ? '--card' : '',
    variant === LOCardVariant.compare ? '--compare' : '',
  ].join(' ')
}
